import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { obtenerDatosHotel } from '../services/motorService';
import Cookies from 'js-cookie';
import Banner from '../components/banner/Banner';
import { useLocation } from 'react-router-dom';

export default function Information() {
  const [datosHotel, setDatosHotel] = useState({});
  //const hotCod = Cookies.get('hotCod');
      const location = useLocation();
      const params = new URLSearchParams(location.search);
      const hotcodParam = params.get('hotcod');
      const hotCod = hotcodParam ?? Cookies.get('hotCod') ?? null;
  useEffect(() => {
    const getData = async () => {
      try {
        const data = await obtenerDatosHotel(hotCod); // Usa hotCod en la llamada a la API
        setDatosHotel(data);
      } catch (error) {
        console.error('Error fetching hotel data:', error);
      }
    };
    getData();
  }, [hotCod]); // hotCod es una dependencia, si cambia, se vuelve a ejecutar el useEffect

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ width: '100vw', position: 'relative', left: '50%', right: '50%', marginLeft: '-50vw', marginRight: '-50vw', overflowX: 'hidden', mt: 2 }}>
            <Banner />
      </Box>
      <Typography variant="h5" component="div" sx={{ mb: 2 }}>
        Información de {datosHotel.MotorHotNombre}
      </Typography>
      <Card sx={{ minWidth: 275 }}>
        <CardContent sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <Typography
            variant="body2"
            component="div"
            color="text.secondary"
            sx={{ fontSize: 16, whiteSpace: "pre-line" }}
          >
            {datosHotel.MotorHotInformacion || 'El hotel no tiene información disponible'}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
}